// @ts-nocheck
import { name2num, num2name, } from "../../../../../../inside/Domain";
import { name2num as name2num_1, num2name as num2name_1, } from "../../../../../../inside/ContentType";
import { name2num as name2num_2, num2name as num2name_2, } from "../../../../../../inside/ContentStatus";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../../../../runtime/json/scalar";
import { WireType, } from "../../../../../../../runtime/wire/index";
import { default as serialize, } from "../../../../../../../runtime/wire/serialize";
import { default as Long, } from "../../../../../../../runtime/Long";
import { default as deserialize, } from "../../../../../../../runtime/wire/deserialize";
import { unpackFns, } from "../../../../../../../runtime/wire/scalar";
export function getDefaultValue() {
    return {
        domain: "UNSPECIFIED_DOMAIN",
        types: [],
        status: "UNSPECIFIED_CONTENT_STATUS",
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.domain !== undefined)
        result.domain = tsValueToJsonValueFns.enum(value.domain);
    result.types = value.types.map(value => tsValueToJsonValueFns.enum(value));
    if (value.status !== undefined)
        result.status = tsValueToJsonValueFns.enum(value.status);
    return result;
}
export function decodeJson(value) {
    var _a, _b;
    const result = getDefaultValue();
    if (value.domain !== undefined)
        result.domain = jsonValueToTsValueFns.enum(value.domain);
    result.types = (_b = (_a = value.types) === null || _a === void 0 ? void 0 : _a.map((value) => jsonValueToTsValueFns.enum(value))) !== null && _b !== void 0 ? _b : [];
    if (value.status !== undefined)
        result.status = jsonValueToTsValueFns.enum(value.status);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.domain !== undefined) {
        const tsValue = value.domain;
        result.push([1, { type: WireType.Varint, value: new Long(name2num[tsValue]) }]);
    }
    for (const tsValue of value.types) {
        result.push([2, { type: WireType.Varint, value: new Long(name2num_1[tsValue]) }]);
    }
    if (value.status !== undefined) {
        const tsValue = value.status;
        result.push([3, { type: WireType.Varint, value: new Long(name2num_2[tsValue]) }]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.Varint ? num2name[wireValue.value[0]] : undefined;
        if (value === undefined)
            break field;
        result.domain = value;
    }
    collection: {
        const wireValues = wireMessage.filter(([fieldNumber]) => fieldNumber === 2).map(([, wireValue]) => wireValue);
        const value = Array.from(unpackFns.int32(wireValues)).map(num => num2name_1[num]);
        if (!value.length)
            break collection;
        result.types = value;
    }
    field: {
        const wireValue = wireFields.get(3);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.Varint ? num2name_2[wireValue.value[0]] : undefined;
        if (value === undefined)
            break field;
        result.status = value;
    }
    return result;
}
